import { MimeContentType } from '../enums/mime-content-type.enum';

export const IMAGE_TYPES = [MimeContentType.Gif, MimeContentType.Png, MimeContentType.Jpg];
